import {createSlice} from "@reduxjs/toolkit";

const deptSlice = createSlice({
    name: "dept",
    initialState: {
        departments: []
    },
    reducers: {
        addDepartment: (state, action) => {
            state.departments.push(action.payload);
        },

        editDepartment: (state, action) => {
            const updatedDept = action.payload;
            for(const item of state.departments){
                if(item.deptId === updatedDept.deptId){
                    item.deptName = updatedDept.deptName;
                    item.deptDesc = updatedDept.deptDesc;
                    item.deptHead = updatedDept.deptHead;
                    break;
                }
            }
            /*state.departments.map((item, index) => {
                if(item.deptId === updatedDept.deptId){
                    return {...item, ...updatedDept};
                }
                return item;
            });
            */
        },
        
    }
});

export const {addDepartment, editDepartment} = deptSlice.actions;
export default deptSlice.reducer;